<script setup lang="ts">
import type { FactSet } from '../types'
import { cn } from '@/lib/utils'
import { spacingClasses } from '../utils/classes'

const props = defineProps<{ element: FactSet }>()
</script>

<template>
  <dl :class="cn('grid grid-cols-[auto_1fr] gap-x-4 gap-y-1', spacingClasses[props.element.spacing ?? 'default'])">
    <template v-for="(fact, index) in props.element.facts" :key="index">
      <dt class="font-semibold text-sm">{{ fact.title }}</dt>
      <dd class="text-sm">{{ fact.value }}</dd>
    </template>
  </dl>
</template>
